var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuEdugames = function SvgMenuEdugames(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.5 30.88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.93 8.66v22.2a21.7 21.7 0 0 1 6.52-5.2 23.8 23.8 0 0 1 8.25-2.29l-.59-22.2S31 .2 25.47 3.87a13.07 13.07 0 0 0-4.54 4.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.58 5.24v19.91A20 20 0 0 0 29 26.83c-4.07 1.94-5.4 4-5.4 4s5.5-2 9.17-1.94a34 34 0 0 1 6.92 1l.81-25.28ZM19.25 8.66v22.2a21.5 21.5 0 0 0-6.51-5.2 23.9 23.9 0 0 0-8.25-2.29L4.33 0a22.45 22.45 0 0 1 10.39 3.87 13 13 0 0 1 4.53 4.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6 5.24v19.91a20.1 20.1 0 0 1 8.61 1.68c4.07 1.94 5.4 4 5.4 4s-5.5-2-9.17-1.94a20.4 20.4 0 0 0-7.44 2L.57 5.75Z"
  })))));
};
export default SvgMenuEdugames;